<template>
    <main class="vertical-center-content">
        <section class="section">
            <div class="container text-center">
                <h1>Please logout</h1>
                <h3>You need to log out before access this page.</h3>
                <p>
                    <a :href="`/logout?redirectUrl=${redirectUrl}`" @click="doLogout" class="btn btn--primary">Logout</a>
                </p>
                <p>
                    <a href="/" class="btn btn--dark-empty">Go to homepage</a>
                </p>
            </div>
        </section>
    </main>
</template>

<script>
export default {
    props: {
        redirectUrl: {
            type: String,
            required: true,
        },
    },
};
</script>
